import React from "react";

export enum GapSize {
  Tiny = "gap-1",
  ExtraSmall = "gap-2",
  Small = "gap-4",
  Medium = "gap-6",
  Large = "gap-8",
  ExtraLarge = "gap-16",
}

type PageContainerProps = {
  hasPadding?: boolean;
  gapSize?: GapSize;
  children: React.ReactNode;
  className?: string;
};

// This component defaults to what the HomePage.tsx will use
const PageContainer = ({
  hasPadding,
  gapSize,
  children,
  className,
}: PageContainerProps) => {
  return (
    <div
      className={`page-container ${hasPadding && "p-4 sm:p-8"} ${
        gapSize ?? GapSize.Large
      } ${className}`}
    >
      {children}
    </div>
  );
};

export default PageContainer;
